<div class="-oneX-container">
    <a class="-oneX-link--block" style="float:right;" href="{{b2bhome}}">
    <div tabindex="0" class="-oneX-icon-container -oneX-interactive" style="height:75px;width:65px;">
        <div class="-oneX-icon -oneX-icon--variant1" data-icon="home_24" style="height:32px;width:32px">
            <span class="-oneX-icon-title-24" style="margin: 0px 0px 0px -20px;white-space: nowrap;">B2B Home</span>
        </div>
    </div>
    </a>
</div>